@import './ui-cms-grid-element';

ui-cms-grid-element {
  > .wrapper {
    margin-top: 0;
  }

  > .wrapper ~ .wrapper {
    margin-top: $sd-spacing-8;
  }
}
